import {cn} from '@/utils';
import React, {useEffect, useState} from 'react';
import {AnimatedCounter} from 'react-animated-counter';

// 背景图片资源
const jackpotBg = require('../../assets/jackpot.png');
const textStyle =
  'bg-gold-text text-[34px] bg-clip-text text-transparent text-center';

interface ScrollingNumberProps {
  targetNumber: number;
  isScrolling?: boolean;
  duration?: number;
}

const ScrollingNumber: React.FC<ScrollingNumberProps> = ({
  targetNumber,
}: {
  targetNumber: number;
}) => {
  return (
    <div className={cn(textStyle, 'flex-1 text-center')}>
      <AnimatedCounter
        containerStyles={{
          marginLeft: 0,
        }}
        fontSize="30px"
        value={targetNumber}
        decimalPrecision={0}
      />
    </div>
  );
};

interface JackpotBannerProps {
  amount?: number;
  autoPlay?: boolean;
}

const JackpotBanner: React.FC<JackpotBannerProps> = ({amount = 0}) => {
  const [displayAmount, setDisplayAmount] = useState(amount);

  // 将数字转换为9位字符串，不足9位前面补0
  const formatAmount = (num: number): string => {
    const maxValue = 999999999; // 9位数字的最大值
    const clampedNum = Math.min(num, maxValue);
    return clampedNum.toString().padStart(9, '0');
  };

  // 当amount参数变化时同步更新
  useEffect(() => {
    setDisplayAmount(amount);
  }, [amount]);

  const formattedAmount = formatAmount(displayAmount);
  return (
    <div className="relative w-full h-[100px] cursor-pointer">
      {/* 背景图片 */}
      <div
        className="absolute bg-no-repeat h-[100px] top-0 left-1/2 transform -translate-x-1/2 w-[351px]"
        style={{
          backgroundImage: `url('${jackpotBg}')`,
          backgroundSize: '100% 100%',
        }}
      />

      {/* 数字显示区域 */}
      <div className="absolute bottom-[13px] h-[42px] left-1/2 -translate-x-1/2 transform w-[290px] flex items-center gap-px">
        {/* 货币符号 */}
        <span className={cn(textStyle, 'w-[28px] flex-shrink-0')}>₹</span>

        {/* 数字部分 */}
        {formattedAmount.split('').map((digit: string, index: number) => (
          <ScrollingNumber key={index} targetNumber={parseInt(digit, 10)} />
        ))}
      </div>
    </div>
  );
};

export default JackpotBanner;
